var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoColoredAiplatform = function SvgLogoColoredAiplatform(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 169 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    transform: "matrix(1,0,0,1,156.493,377.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    d: "M-141.2,-363C-142.9,-363 -144.3,-364.3 -144.3,-366L-144.3,-366.2C-144.3,-367.9 -143,-369.4 -141.2,-369.4L-141.1,-369.4C-139.3,-369.4 -137.9,-368 -137.9,-366.2C-137.9,-364.4 -139.3,-363 -141.1,-363L-141.2,-363Z",
    style: {
      fill: "rgb(98,180,246)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    transform: "matrix(1,0,0,1,0.868,10.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    d: "M-139,-342.8L-141.6,-342.8C-143,-342.8 -144.2,-344 -144.2,-345.4L-144.2,-366.7C-144.2,-367.8 -143.5,-368.8 -142.4,-369.2C-141,-369.7 -139.5,-368.9 -139.1,-367.5C-139,-367.2 -139,-367 -139,-366.7L-139,-342.8Z",
    style: {
      fill: "rgb(98,180,246)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    transform: "matrix(1,0,0,1,11.903,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    transform: "matrix(1,0,0,1,24.58,0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    d: "M23.8,54.7C22,54.7 20.6,53.2 20.6,51.5C20.6,49.7 22.1,48.3 23.8,48.3C25.5,48.3 26.9,49.6 26.9,51.3L26.9,51.5C26.9,53.2 25.6,54.7 23.8,54.7C23.9,54.7 23.9,54.7 23.8,54.7ZM23.8,44.5C22.4,44.5 21.2,43.3 21.2,41.9L21.2,18L23.8,18C25.3,18 26.4,19.2 26.4,20.6L26.4,41.9C26.5,43.3 25.3,44.5 23.8,44.5Z",
    style: {
      fill: "rgb(122,225,137)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    d: "M28.9,45.6C23.3,45.6 20.7,41.6 20.7,37.9C20.6,35.6 21.5,33.4 23.1,31.8C25.6,29.3 30.2,27.9 36.3,27.9L36.3,27.6C36.4,26 35.9,24.5 34.8,23.3C33.7,22.3 32.1,21.8 30.6,21.9C28.8,21.9 27.1,22.3 25.4,23C24.9,23.2 24.4,23.2 23.9,23C23.4,22.8 23,22.4 22.8,21.9C22.5,21 22.9,20 23.8,19.6C26.1,18.5 28.7,18 31.2,18C39.6,18 41.3,23.9 41.3,28.8L41.3,38.5C41.3,40.1 41.4,41.6 41.5,42.9C41.6,43.9 40.8,44.9 39.8,45L38.7,45C37.7,45 36.9,44.3 36.8,43.3L36.8,42C34.8,44.3 31.9,45.7 28.9,45.6ZM35,31.8C28.9,32 25.9,33.9 25.9,37.4C25.7,39.5 27.3,41.4 29.4,41.6L30,41.6C32.7,41.7 35.2,40 36.1,37.4C36.2,36.9 36.3,36.5 36.3,36L36.3,33.1C36.3,32.7 36.1,32.4 35.9,32.1C35.7,31.9 35.4,31.8 35,31.8Z",
    style: {
      fill: "rgb(122,225,137)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    transform: "matrix(1,0,0,1,0,0.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    d: "M21.4,44.7L21.1,44.7C20.7,44.6 20.6,44.2 20.7,43.8L30.5,18.6C30.6,18.2 31,18.1 31.4,18.2C31.8,18.3 31.9,18.7 31.8,19.1L22,44.2C21.9,44.4 21.8,44.5 21.6,44.6C21.6,44.7 21.5,44.7 21.4,44.7Z",
    style: {
      fill: "rgb(122,225,137)",
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_text"
  }, /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 30,
    fontFamily: "'Nunito', Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "rgb(123,225,138)",
    letterSpacing: 1.4,
    textAnchor: "start"
  }, "AI"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 45,
    fontFamily: "'Nunito', Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "rgb(123,225,138)",
    letterSpacing: 1.4,
    textAnchor: "start"
  }, "PLATFORM")))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoColoredAiplatform);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_colored_aiplatform.a409c43a22ccd6f240d03037f8f63b68.svg";